export const MAINTENANCE_PAGE_TYPES = Object.freeze({
  NOT_AUTHORIZED: 'notAuthorized',
  NOT_FOUND: 'notFound'
})
